import { DefaultThunk } from "stores";
import { UpdateEffect } from "stores/modules/entities.room.effects";
import {
  deleteRoomEffect,
  updateRoomEffect,
} from "stores/modules/entities.room.effects/operations";

export type UpdateEffectRecord = {
  kind: "update-effect";
  id: string;
  before: UpdateEffect | null;
  after: UpdateEffect | null;
};

export const undoUpdateEffect =
  (history: UpdateEffectRecord): DefaultThunk =>
  (dispatch, getState) => {
    const roomId = getState().app.state.roomId;
    if (!roomId) return;
    const before = history.before;

    if (!before) {
      // 変更前データがない場合は追加が行われたとして削除処理
      dispatch(deleteRoomEffect(roomId, history.id));
      return;
    }

    // それ以外の場合は通常の更新処理
    dispatch(updateRoomEffect(roomId, history.id, before));
    return;
  };

export const redoUpdateEffect =
  (history: UpdateEffectRecord): DefaultThunk =>
  (dispatch, getState) => {
    const roomId = getState().app.state.roomId;
    if (!roomId) return;
    const after = history.after;

    if (!after) {
      // 変更後データがない場合は削除処理
      dispatch(deleteRoomEffect(roomId, history.id));
      return;
    }

    // それ以外の場合は通常の更新処理
    dispatch(updateRoomEffect(roomId, history.id, after));
    return;
  };
